import React, {useRef, useState} from "react"
import {useParams} from "react-router"
import Title from '@base/Title'
import Toast from '@base/Toast'
import {ProcessoResolver} from "@helpers/ProcessoHelper"
import CartoesTableView from "@pages/Escola/Cartoes/componentes/CartoesTableView"
import QuantitativoTratamentoNome from "@pages/TratamentoNomes/QuantitativoTratamentoNome"

export const DashboardTratamentoNomes = () => {
	const toastRef = useRef(null);
  const cartoesTableViewRef = useRef(null);

	const params = useParams();
	const processo = ProcessoResolver(params.processo);

	const [horaUltimoRefresh,setHoraUltimoRefresh] = useState();
	const [horaUltimoRefreshQuantitativo,setHoraUltimoRefreshQuantitativo] = useState();

	const atualizaFiltros = (tipo,status) => {

		if (cartoesTableViewRef.current) {
	  		cartoesTableViewRef.current.atualizarFiltrosQuantitativosNome(tipo,status);
		}else{
			console.log("current null");
		}
  }


	const columns = [
		{label: 'id', 					name: 'id',hidden: true, key: true },
		{label: 'Origem do Cartão', name: 'origem', filter: 'objetoPostal.origem', func: (objColuna,objLinha) => objColuna ? objColuna.descricao : "",key: false },
		{label: 'Código', name: 'codigo', key: false},
		{label: 'Nome', name: 'nomeAluno', 
			filter: 'aluno.nome', 
			func: (objColuna,objLinha) => <> 
					{objColuna}
					{objLinha.tratamentoNome && objLinha.tratamentoNome.nomeSubstituido ? 
					<span style={{display:"block", fontSize:11, color:"#999"}}>{objLinha.tratamentoNome.nomeSubstituido }
					</span> : "" }</> , key: false},
					
		{label: 'Tipo', name: 'tipoTratamentoNome', func: (objColuna,objLinha) => <> {objLinha.tratamentoNome ? <>{objLinha.tratamentoNome.tipoLabel}</> : ""}</> ,	key: false, ordering: false},
		{label: 'Origem do Problema',	name: 'tipoTratamentoOrigem', filter: 'tratamentoNome.origemProblema', func: (objColuna,objLinha) => <> {objLinha.tratamentoNome ? (objLinha.tratamentoNome.origem === "OUTRO" ? <>{objLinha.tratamentoNome.origem}<span style={{display:"block", fontSize:11, color:"#999"}}>{objLinha.tratamentoNome.descricaoOrigemOutro }</span></>  : objLinha.tratamentoNome.origem) : "--"}</> ,	key: false},
		{label: 'Status do Tratamento',	name: 'statusTratamentoNome', filter: 'tratamentoNome.status', func: (objColuna,objLinha) => <> {objLinha.tratamentoNome ? objLinha.tratamentoNome.statusLabel : ""}{objLinha.tratamentoNome && objLinha.tratamentoNome.responsavel ? <span style={{display:"block", color:"#999", fontSize:11}}>{objLinha.tratamentoNome.responsavel }</span> : "" }</> ,key: false}, ];


	return (
		<>
			<Toast ref={toastRef} />
			<Title>Tratamento de Nomes</Title>

			<QuantitativoTratamentoNome aoClicarEmQuantitativo={atualizaFiltros}
				refresh={horaUltimoRefreshQuantitativo}
				processo={processo.id} />

			<CartoesTableView
				ref={cartoesTableViewRef}
        		refresh={horaUltimoRefresh}
				exibeFiltro={true}
				exibeFiltroTratamentoNome={true}
				permiteDigitarCartao={false}
				permiteEditarCartao={false}
				permiteSubstituirCartao={false}
				permiteAnexarDigitalizacao={false}
				permiteTratarPendenciaNome={true}
				permiteReetiquetar={false}
				permiteDescartarCartao={true}
				mensagemInformativaAoDescartarCartao={"Ao descartar o cartão a pendência de nome será automaticamente atualizada para 'Resolvida'"}
				colunas={columns}
				processo={processo.id}
				somenteComTratamentoNome={true}
				aoAtualizarStatusTratamentoNome={(cartao, cartoes, setCartoes,filtroStatus) => {

						let cartoesTemp = cartoes.map(c => {

							if(c.id === cartao.data.id){
								if(filtroStatus !== undefined && filtroStatus !== ""){
									if(filtroStatus !== cartao.data.statusTratamentoNome){
										return null;
									}else{
										return cartao.data;
									}
								}else{
									return cartao.data;
								}
							}else{
								return c;
							}

						} );


						setCartoes(cartoesTemp.filter(cartao => cartao != null));
           				//setHoraUltimoRefreshQuantitativo(new Date());
					}
				}
				motivosDescarteDisponiveis={() => {
					return [{ value: 'TRATAMENTO_NOME', label: 'Tratamento de Nome' }]
				}}
				aoDescartarCartao={(cartao) => { setHoraUltimoRefresh(new Date());  setHoraUltimoRefreshQuantitativo(new Date()); }}
				aoRestaurarCartao={(cartao) => { setHoraUltimoRefresh(new Date()); setHoraUltimoRefreshQuantitativo(new Date());}}
				/>
		</>
	);
}

export default DashboardTratamentoNomes;
